  const newsState = {
    published: 0,
    draft: 1,
    archived: 2,
    default: 3,
  };
  export default newsState;
